import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ProfileModel } from "../../models/profile.model";
import { Subscription } from "rxjs";
import { ProfileService } from "../../services/profile.service";
import { AuthService } from "../../services/auth.service";

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: false
})
export class BreadcrumbComponent implements OnInit, OnDestroy {

  @Input() breadcrumb: string;

  profileInfo: ProfileModel;
  profilePic: any;

  private profileSubs: Subscription;

  constructor(
    private readonly profileService: ProfileService,
    private readonly authService: AuthService
  ) { }

  ngOnInit(): void {
    this.getProfile();
  }

  ngOnDestroy(): void {
    if (this.profileSubs) { this.profileSubs.unsubscribe(); }
  }

  private getProfile(): void {
    this.profileSubs = this.profileService.getAzureProfileData(this.authService.userId)
      .subscribe(data => {
        if(!data["error"]) {
          this.profileInfo = data;
        }
      });
  }

}
